import React from 'react';
import { motion } from 'framer-motion';

/**
 * Premium "Live" indicator with a soft pulsing dot. Replaces the static
 * "Updated at HH:MM" label for a more fintech feel.
 */
const LivePulseIndicator = ({ updating, lastUpdate, label = 'Live' }) => {
  const ts = lastUpdate ? new Date(lastUpdate).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : null;
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-400/20" data-testid="live-pulse-indicator">
      <span className="relative inline-flex w-2 h-2">
        <motion.span
          className="absolute inset-0 rounded-full bg-emerald-400"
          animate={updating ? { scale: [1, 2.2, 1], opacity: [0.7, 0, 0.7] } : { scale: [1, 1.8, 1], opacity: [0.6, 0.1, 0.6] }}
          transition={{ duration: updating ? 0.8 : 2.4, repeat: Infinity, ease: 'easeOut' }}
        />
        <span className="relative inline-flex w-2 h-2 rounded-full bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.8)]" />
      </span>
      <span className="text-xs font-bold text-emerald-300 uppercase tracking-wider">{label}</span>
      {ts && <span className="text-[10px] text-emerald-300/60 font-mono hidden sm:inline">{ts}</span>}
    </div>
  );
};

export default LivePulseIndicator;
